(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kova-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('kova-countdown-bar'))customElements.define('kova-countdown-bar',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      var totalMinutes=parseFloat(this.dataset.durationMinutes)||694;
      var durationMs=totalMinutes*60000;
      var key='kova_countdown_v2_'+this.dataset.sectionId+'_'+(this.dataset.reset||'');
      var target=0;
      try{target=parseInt(localStorage.getItem(key),10);}catch(e){}
      var now=Date.now();
      if(!target||isNaN(target)||target<=now||target>now+durationMs){
        target=now+durationMs;
        try{localStorage.setItem(key,String(target));}catch(e){}
      }
      var hEl=this.querySelector('[data-kcb-h]');
      var mEl=this.querySelector('[data-kcb-m]');
      var sEl=this.querySelector('[data-kcb-s]');
      function tick(){
        var diff=target-Date.now();
        if(diff<=0){
          target=Date.now()+durationMs;
          try{localStorage.setItem(key,String(target));}catch(e){}
          diff=target-Date.now();
        }
        var h=Math.floor(diff/3600000),m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000);
        if(hEl)hEl.textContent=String(h).padStart(2,'0');
        if(mEl)mEl.textContent=String(m).padStart(2,'0');
        if(sEl)sEl.textContent=String(s).padStart(2,'0');
      }
      tick();
      this._kcbInterval=setInterval(tick,1000);
    }
    disconnectedCallback(){if(this._kcbInterval)clearInterval(this._kcbInterval);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-product"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('kova-product'))customElements.define('kova-product',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      const countdownEl=this.querySelector('[data-sale-ends]');
      if(countdownEl){
        const target=new Date(countdownEl.dataset.saleEnds).getTime();
        const valueEl=countdownEl.querySelector('[data-countdown-value]');
        const tick=()=>{
          const diff=target-Date.now();
          if(isNaN(target)||diff<=0){countdownEl.hidden=true;return;}
          const h=Math.floor(diff/3600000),m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000);
          if(valueEl)valueEl.textContent=(h>0?String(h).padStart(2,'0')+':':'')+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
        };
        tick();this._countdownInterval=setInterval(tick,1000);
      }
      this.addEventListener('change',event=>{if(!event.target.matches('input[name="id"]'))return;const selected=event.target;this.querySelectorAll('[data-current-price]').forEach(el=>el.textContent=selected.dataset.price);const compareRow=this.querySelector('.kp-price--compare');if(compareRow){const compareWas=compareRow.querySelector('.kp-price-was');const compareBadge=compareRow.querySelector('.kp-price-save-badge');if(selected.dataset.compare){if(compareWas){compareWas.textContent=selected.dataset.compare;compareWas.hidden=false;}if(compareBadge){compareBadge.textContent=(compareRow.dataset.saveLabel||'Ahorra')+' '+selected.dataset.save;compareBadge.hidden=false;}}else{if(compareWas)compareWas.hidden=true;if(compareBadge)compareBadge.hidden=true;}}const button=this.querySelector('.kp-buy');button.disabled=selected.dataset.available!=='true';button.textContent=button.disabled?this.dataset.unavailable:this.dataset.buy;const stockLine=this.querySelector('[data-stock-line]');if(stockLine){const stockText=stockLine.querySelector('[data-stock-text]');const qty=parseInt(selected.dataset.stock||'0',10);if(qty>0&&stockText){stockLine.hidden=false;stockText.textContent=stockText.textContent.replace(/\d+/,qty);}else if(stockLine){stockLine.hidden=true;}}const availText=this.querySelector('[data-availability-text]');if(availText&&selected.dataset.title)availText.textContent=selected.dataset.title+' — '+(this.dataset.productTitle||'');const url=new URL(location.href);url.searchParams.set('variant',selected.value);history.replaceState({},'',url);});
      this.addEventListener('click',event=>{const thumb=event.target.closest('[data-thumb]');if(thumb){this.querySelectorAll('[data-photo]').forEach(el=>el.hidden=el.dataset.photo!==thumb.dataset.thumb);this.querySelectorAll('[data-thumb]').forEach(el=>el.setAttribute('aria-pressed',String(el===thumb)));}const photo=event.target.closest('[data-photo]');if(photo){const dialog=this.querySelector('dialog');const image=photo.querySelector('img').cloneNode();image.removeAttribute('loading');dialog.querySelector('[data-zoom-content]').replaceChildren(image);dialog.showModal();}if(event.target.closest('[data-close]'))this.querySelector('dialog').close();});
      const dialog=this.querySelector('dialog');if(dialog)dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    }
  });
  (function(){
    var names=[["María","Arequipa"],["Diana","Tacna"],["Jorge","Trujillo"],["Rosa","Cusco"],["Luis","Chiclayo"],["Carla","Huancayo"],["Pedro","Piura"],["Ana","Lima"],["Miguel","Ica"],["Sofía","Callao"]];
    function initSocialProof(el){
      var nameEl=el.querySelector('.kp-social-proof__name');
      var productEl=el.querySelector('.kp-social-proof__product');
      var timeEl=el.querySelector('.kp-social-proof__time');
      var avatarEl=el.querySelector('.kp-social-proof__avatar');
      var closeBtn=el.querySelector('.kp-social-proof__close');
      var product=el.dataset.productTitle||'este producto';
      var dismissed=false;
      closeBtn.addEventListener('click',function(){el.classList.remove('is-visible');dismissed=true;});
      function show(){
        if(dismissed)return;
        var pick=names[Math.floor(Math.random()*names.length)];
        var minutes=4+Math.floor(Math.random()*54);
        nameEl.textContent=pick[0]+' de '+pick[1];
        productEl.textContent='Compró: '+product;
        timeEl.textContent='hace '+minutes+' minutos';
        avatarEl.textContent=pick[0].charAt(0);
        el.hidden=false;
        requestAnimationFrame(function(){el.classList.add('is-visible');});
        setTimeout(function(){el.classList.remove('is-visible');setTimeout(function(){if(!el.classList.contains('is-visible'))el.hidden=true;},400);},7000);
      }
      setTimeout(function(){show();setInterval(function(){show();},20000);},4000);
    }
    document.querySelectorAll('.kp-social-proof').forEach(initSocialProof);
  })();
  (function(){
    document.querySelectorAll('.kp-compare-slider').forEach(function(el){
      var range=el.querySelector('.kp-compare-range');
      if(!range)return;
      range.addEventListener('input',function(){el.style.setProperty('--kp-compare-pos',range.value+'%');});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
